import { defineComponent } from 'vue';
import { Progress } from '@/components/UI';
import useTranslations from '@/compositions/useTranslations';
export default defineComponent({
    name: 'LevelStatus',
    components: {
        Progress
    },
    setup: () => ({
        ...useTranslations()
    }),
    computed: {
        percentage() {
            return this.$store.direct.state.rooms.score;
        }
    }
});
